import { io } from "socket.io-client";

export const STATUS = {
  CONNECTED: "CONNECTED",
  DISCONNECTED: "DISCONNECTED",
  CONNECTING: "CONNECTING",
  ERROR: "ERROR"
};

export function createSocketManager({ onConnect, onRecovered, onDisconnect }) {
  let socket = null;
  let status = STATUS.DISCONNECTED;
  let wasDisconnected = false;
  const subscribers = new Set();

  function notify() {
    subscribers.forEach(fn => fn(status));
  }

  function setStatus(newStatus) {
    status = newStatus;
    notify();
  }

  function subscribeStatus(fn) {
    subscribers.add(fn);
    fn(status);
    return () => subscribers.delete(fn);
  }

  async function connect({ url, transports, token }) {
    if (socket) return socket;

    setStatus(STATUS.CONNECTING);

    socket = io(url, {
      transports,
      auth: { token }
    });

    socket.on("connect", async () => {
      setStatus(STATUS.CONNECTED);
      if (wasDisconnected) {
        wasDisconnected = false;
        onRecovered?.();
      } else {
        onConnect?.();
      }
    });

    socket.on("disconnect", async () => {
      setStatus(STATUS.DISCONNECTED);
      wasDisconnected = true;
      await onDisconnect?.();
    });

    socket.on("connect_error", () => {
      setStatus(STATUS.ERROR);
    });

    return socket;
  }

  function getStatus() {
    return status;
  }

  function disconnect() {
    if (!socket) return;

    socket.disconnect();
    socket = null;
    setStatus(STATUS.DISCONNECTED);
  }

  function emit(event, payload) {
    if (!socket || socket.disconnected) {
      return;
    }

    socket.emit(event, payload);
  }

  return {
    connect,
    disconnect,
    subscribeStatus,
    getStatus,
    emit
  };
}